import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Hook to check if the current user is a developer
 * Returns developer status
 */
export function useIsDeveloper() {
  const [isDeveloper, setIsDeveloper] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkDeveloper = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session?.user) {
          setIsDeveloper(false);
          setIsLoading(false);
          return;
        }

        // Check if user is in developer_profiles table and is_active
        const { data: devProfile, error } = await supabase
          .from('developer_profiles')
          .select('is_active')
          .eq('id', session.user.id)
          .maybeSingle();

        if (error || !devProfile) {
          setIsDeveloper(false);
          return;
        }

        setIsDeveloper(devProfile.is_active === true);
      } catch (err) {
        console.error('Developer check failed:', err);
        setIsDeveloper(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkDeveloper();
  }, []);

  return { isDeveloper, isLoading };
}






